import { ClientApp } from '@application/components/app';
import { hydrateRoot } from 'react-dom/client';

/*
    NOTE from old developer to future developer: 
    Both founders are assholes with no computer knowledge
    Who think they know better than us developers
    They request a feature be done in a certain amount of time
    Sorry in advance, some code is pure garbage shit
    Had to cut some corners to satisfy their stupid time estimations 
    Good luck debugging this shit :)

    ps: You're not their friend, you're just a cheaply hired developer from a third world country to them.
*/

// Normally, we would use hydrate to build on top of the server markup,
// But this is causing lots of errors
hydrateRoot(document.getElementById('root')!, <ClientApp />);

// const rootElement = document.getElementById('root');
// const root = createRoot(rootElement!);
// root.render(<ClientApp />);
